import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-114baa4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydownCapture"]
const _hoisted_2 = { class: "flex justify-between pb-2" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "text-lg font-bold"
}
const _hoisted_5 = { class: "-mr-2 -mt-2 ml-4 flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  id: "videoPlayer",
  class: "video-js vjs-default-skin absolute left-0 top-0 h-full w-full",
  controls: ""
}, null, -1))

import {
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import videojs from 'video.js';
import {
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';
import 'video.js/dist/video-js.css';
import 'videojs-youtube';
import {
  extractYoutubeVideoId,
} from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubeVideoModal',
  props: {
  videoUrl: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  boxClass: {
    type: String,
    default: 'max-w-screen-lg',
  },
  isMuted: {
    type: Boolean,
    default: false,
  },
  allowMoreOption: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props) {

const props = __props;






const isFullscreen = ref(false);
const hasStartedPlaying = ref(false);

let player: videojs.Player;

let videoContextMenuHandler: ((e: Event) => void) | undefined;
let videoControlsContextMenuHandler: ((e: Event) => void) | undefined;
let protectiveOverlayHandler: ((e: Event) => void) | undefined;

function handleKeyPress(event: KeyboardEvent): boolean {
  if (event.ctrlKey || event.metaKey) {
    event.preventDefault();
    return false;
  }

  if (event.key.startsWith('F')) {
    event.preventDefault();
    return false;
  }

  return true;
}

// Utility function to prevent event propagation
const preventPropagation = (e: Event): void => {
  e.stopPropagation();
};

// eslint-disable-next-line max-lines-per-function
onMounted(() => {
  player = videojs('videoPlayer', {
    techOrder: ['youtube'],
    sources: [
      {
        type: 'video/youtube',
        src: `https://www.youtube.com/watch?v=${extractYoutubeVideoId(props.videoUrl)}`,
      },
    ],
    youtube: {
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      autohide: 2,
      controls: 1,
      iv_load_policy: 3,
    },
    controlBar: {
      children: [
        'playToggle',
        'volumePanel',
        'playbackRateMenuButton',
        'fullscreenToggle',
        'remainingTimeDisplay',
        'currentTimeDisplay',
        'timeDivider',
        'durationDisplay',
        'progressControl',
        'pictureInPictureToggle',
      ],
    },
    playbackRates: [0.5, 1, 1.25, 1.5, 2],
  });

  player.on('play', () => {
    if (!hasStartedPlaying.value) {
      hasStartedPlaying.value = true;
    }
  });

  // Prevent right-click on video
  const videoElement = document.querySelector('.video-js');
  if (videoElement) {
    videoContextMenuHandler = (e): void => e.preventDefault();
    videoElement.addEventListener('contextmenu', videoContextMenuHandler);
  }

  player.on('fullscreenchange', () => {
    isFullscreen.value = player.isFullscreen();

    const fullscreenElement = document.fullscreenElement
        || document.webkitFullscreenElement
        || document.mozFullScreenElement
        || document.msFullscreenElement;

    const protectiveOverlay = document.querySelector('.protective-overlay');
    const initialOverlays = document.querySelector('.initial-overlays');
    const bottomRightOverlay = document.querySelector('.bottom-right-overlay');

    if (fullscreenElement) {
      if (protectiveOverlay) fullscreenElement.appendChild(protectiveOverlay);
      if (initialOverlays) fullscreenElement.appendChild(initialOverlays);
      if (bottomRightOverlay) fullscreenElement.appendChild(bottomRightOverlay);
    } else {
      const videoWrapper = document.querySelector('.video-player-wrapper');
      if (videoWrapper) {
        if (protectiveOverlay) videoWrapper.appendChild(protectiveOverlay);
        if (initialOverlays) videoWrapper.appendChild(initialOverlays);
        if (bottomRightOverlay) videoWrapper.appendChild(bottomRightOverlay);
      }
    }
  });

  // Ensure playback rate menu is clickable
  const setupPlaybackRateMenu = (): void => {
    const playbackRateButton = document.querySelector('.vjs-playback-rate');
    const playbackRateMenu = document.querySelector('.vjs-playback-rate .vjs-menu');
    const playbackRateMenuContent = document.querySelector('.vjs-playback-rate .vjs-menu-content');

    if (playbackRateButton) {
      // Remove event prevention on the button
      playbackRateButton.removeEventListener('mousedown', preventPropagation);
      playbackRateButton.removeEventListener('click', preventPropagation);
    }

    if (playbackRateMenu) {
      // Remove event prevention on the menu
      playbackRateMenu.removeEventListener('mousedown', preventPropagation);
      playbackRateMenu.removeEventListener('click', preventPropagation);

      // Ensure menu is clickable
      playbackRateMenu.setAttribute('style', 'pointer-events: auto !important; z-index: 10002 !important;');
    }

    if (playbackRateMenuContent) {
      // Ensure menu content is clickable
      playbackRateMenuContent.setAttribute('style', 'pointer-events: auto !important; z-index: 10003 !important;');

      // Add click event listeners to menu items
      const menuItems = playbackRateMenuContent.querySelectorAll('.vjs-menu-item');
      menuItems.forEach((item) => {
        item.setAttribute('style', 'pointer-events: auto !important; cursor: pointer !important;');

        // Remove any existing event listeners that might prevent interaction
        item.removeEventListener('mousedown', preventPropagation);
        item.removeEventListener('click', preventPropagation);

        // Add a new click listener that allows interaction
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          (item as HTMLElement).click();
        });
      });
    }
  };

  // Modify the protective overlay to prevent interactions
  const setupProtectiveOverlay = (): void => {
    const protectiveOverlay = document.querySelector('.protective-overlay');
    if (protectiveOverlay) {
      protectiveOverlayHandler = (e): void => {
        // Block interactions on the protective overlay
        const playbackRateMenu = document.querySelector('.vjs-playback-rate .vjs-menu');
        if (!playbackRateMenu || !playbackRateMenu.contains(e.target as Node)) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      protectiveOverlay.addEventListener('mousedown', protectiveOverlayHandler);
    }
  };

  // Call setup functions after a short delay to ensure DOM is ready
  setTimeout(() => {
    setupPlaybackRateMenu();
    setupProtectiveOverlay();
  }, 500);

  // Additional setup to ensure menu is always clickable
  const setupMenuInteractions = (): void => {
    const playbackRateButton = document.querySelector('.vjs-playback-rate');
    if (playbackRateButton) {
      playbackRateButton.setAttribute('style', 'z-index: 10002 !important;');
    }

    const playbackRateMenu = document.querySelector('.vjs-playback-rate .vjs-menu');
    if (playbackRateMenu) {
      playbackRateMenu.setAttribute('style', 'pointer-events: auto !important; z-index: 10002 !important;');
    }
  };

  // Ensure menu interactions are set up
  setTimeout(setupMenuInteractions, 1000);

  // Prevent default contextmenu on video and its controls
  const videoControls = document.querySelector('.video-js .vjs-control-bar');
  if (videoControls) {
    videoControlsContextMenuHandler = (e): void => e.preventDefault();
    videoControls.addEventListener('contextmenu', videoControlsContextMenuHandler);
  }
});

onBeforeUnmount(() => {
  // Clean up all DOM event listeners
  const videoElement = document.querySelector('.video-js');
  if (videoElement && videoContextMenuHandler) {
    videoElement.removeEventListener('contextmenu', videoContextMenuHandler);
  }

  const videoControls = document.querySelector('.video-js .vjs-control-bar');
  if (videoControls && videoControlsContextMenuHandler) {
    videoControls.removeEventListener('contextmenu', videoControlsContextMenuHandler);
  }

  const protectiveOverlay = document.querySelector('.protective-overlay');
  if (protectiveOverlay && protectiveOverlayHandler) {
    protectiveOverlay.removeEventListener('mousedown', protectiveOverlayHandler);
  }

  // Clean up playback rate menu event listeners
  const playbackRateButton = document.querySelector('.vjs-playback-rate');
  if (playbackRateButton) {
    playbackRateButton.removeEventListener('mousedown', preventPropagation);
    playbackRateButton.removeEventListener('click', preventPropagation);
  }

  const playbackRateMenu = document.querySelector('.vjs-playback-rate .vjs-menu');
  if (playbackRateMenu) {
    playbackRateMenu.removeEventListener('mousedown', preventPropagation);
    playbackRateMenu.removeEventListener('click', preventPropagation);
  }

  const playbackRateMenuContent = document.querySelector('.vjs-playback-rate .vjs-menu-content');
  if (playbackRateMenuContent) {
    const menuItems = playbackRateMenuContent.querySelectorAll('.vjs-menu-item');
    menuItems.forEach((item) => {
      item.removeEventListener('mousedown', preventPropagation);
      item.removeEventListener('click', preventPropagation);
    });
  }

  // Dispose video player
  if (player) {
    player.dispose();
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "video-modal",
    class: "modal modal-open",
    onContextmenu: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
    onKeydownCapture: _withModifiers(handleKeyPress, ["prevent"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-box relative", __props.boxClass])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-circle border-0 font-bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createVNode(_unref(XMarkIcon), { class: "size-6 text-violet-600" })
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "video-player-wrapper",
        onContextmenu: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _hoisted_6,
        (hasStartedPlaying.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["protective-overlay", { 'is-fullscreen': isFullscreen.value }])
            }, null, 2))
          : _createCommentVNode("", true)
      ], 32)
    ], 2)
  ], 40, _hoisted_1))
}
}

})